export const ORDER_STATUS = {
  PENDING: "pending",
  PROCESSING: "processing",
  SUCCESS: "success",
};

export const ORDER_CREATE_PAYMENT_METHODS_BACKEND = {
  COD: "Cash on Delivery",
  UPI: "Axis Bank UPI",
  DEFAULT_UPI: "upi",
  DEFAULT_COD: "cod",
};
